<script>
		import {user, game, view} from "../client.svelte.js";

		let {extended = false} = $props()
		let sessions = $derived(
			user.sessions.values()
				.filter(sess => sess.TALE === game.tale && (!view.section || (sess.stages ?? []).includes(view.section.ID)))
				.toArray()
				.toSorted((a, b) => Number(a.STEP) - Number(b.STEP))
				.map(sess => Object.assign({}, sess,
						{started: (sess.started) ? new Date(sess.started).toLocaleDateString('de-DE') : "",
					 players: Object.keys(sess.players ?? {}).join(", "),
						 stages: (sess.stages ?? []).map(sectID => user.sections.get(sectID)?.name ?? sectID).join(", ")})))
		let columns = $derived((extended) ? {STEP: "Nr", started: "Datum", stages: "Abschnitte", notes: "Notizen"} : {STEP: "Nr", started: "Datum", players: "Spieler"})
		let cells = $derived(sessions.map(sess => Object.keys(columns).map(key => sess[key])))
</script>


<!------------------------------- HTML ------------------------------------->

<table id=sessionsTable>
	<thead>
		<tr>
			{#each Object.values(columns) as column}
				<th>{column}</th>
			{/each}
		</tr>
	</thead>

	<tbody>
		{#each cells as line}
			<tr>
				{#each line as cell}
					<td>{cell ?? ""}</td>
				{/each}
			</tr>
		{/each}
	</tbody>
</table>


<style lang="sass">
	@use "../colors" as colors

	tr td:focus
		background: black
		color: colors.$white
</style>
